export default __webpack_public_path__ + "static/media/noVacancies.b63645b7.jpeg";